import api from './api';

const marketplaceService = {
  getAllSettings: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.category) params.append('category', filters.category);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/admin/marketplace${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  // Read-only marketplace catalog for normal (non-superadmin) users.
  // Served by the main API at GET /marketplace (no /admin prefix, no secrets).
  getCatalog: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/marketplace${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  getSettingById: async (id) => {
    const response = await api.get(`/admin/marketplace/${id}`);
    return response.data;
  },

  createSetting: async (settingData) => {
    const response = await api.post('/admin/marketplace', settingData);
    return response.data;
  },

  updateSetting: async (id, settingData) => {
    const response = await api.put(`/admin/marketplace/${id}`, settingData);
    return response.data;
  },

  deleteSetting: async (id) => {
    const response = await api.delete(`/admin/marketplace/${id}`);
    return response.data;
  }
};

export default marketplaceService;
